import { render, staticRenderFns } from "./ExamData.vue?vue&type=template&id=60a4f8a2&scoped=true&"
import script from "./ExamData.vue?vue&type=script&lang=js&"
export * from "./ExamData.vue?vue&type=script&lang=js&"
import style0 from "./ExamData.vue?vue&type=style&index=0&id=60a4f8a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a4f8a2",
  null
  
)

export default component.exports